import Image from 'next/image'
import React from 'react'

const certifications = [
  {
    id: 'soc-2',
    name: 'AICPA SOC 2 Service Organization Control Reports certification',
    src: '/assets-rebrand/certifications/soc-2-logo.webp',
    className: 'h-auto w-[55px] md:w-[70px] lg:w-20',
  },
  {
    id: 'cyber-essentials',
    name: 'Cyber Essentials PLUS certification',
    src: '/assets-rebrand/certifications/cyber-essentials-plus-logo.png',
    className: 'h-auto w-[57px] md:w-[90px] lg:w-[114px]',
  },
  {
    id: 'crown-commercial',
    name: 'Crown Commercial Service certification',
    src: '/assets-rebrand/certifications/crown-commercial-service-supplier-logo.svg',
    className: 'h-auto w-[52px] md:w-20 lg:w-[104px]',
  },
  {
    id: 'g-cloud',
    name: 'G-Cloud UK Government certification',
    src: '/assets-rebrand/certifications/government-cloud-supplier-logo.webp',
    className: 'h-auto w-[77px] md:w-[120px] lg:w-[153px]',
  },
  {
    id: 'iso-27001',
    name: 'ISO 27001 Information Security Management certification',
    src: '/assets-rebrand/certifications/iso-27001-logo.png',
    className: 'h-auto w-[100px] md:w-[110px] lg:w-[130px]',
  },
]

export const ComplianceBanner: React.FC = () => {
  return (
    <section className="bg-civo-cloud h-20 md:h-24 px-4 md:px-9 xl:px-16">
      <div className="flex items-center justify-center md:justify-between gap-4 h-full max-w-7xl mx-auto">
        {certifications.map((cert) => (
          <div
            key={cert.id}
            className="flex items-center justify-center h-full"
          >
            <Image
              src={cert.src}
              alt={cert.name}
              width={200}
              height={200}
              className={`object-contain ${cert.className}`}
              sizes="(max-width: 1024px) 100px, 200px"
            />
          </div>
        ))}
      </div>
    </section>
  )
}